import { groupHasConfiguredDataDisk, isImageBackfillGroup, parseAppStorageGroupsField } from './appStorageGroups';

/**
 * SKU 预置是否已配置应用存储。
 * 有已配数据盘，或镜像回填存储组，即视为预置完整（下单禁删改）。
 */
export function hasPresetAppStorage(preset?: Record<string, unknown> | null): boolean {
  if (!preset) return false;
  const groups = parseAppStorageGroupsField(preset._appStorageGroups);
  return groups.some((group) => groupHasConfiguredDataDisk(group) || isImageBackfillGroup(group));
}
